import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';

const INNER_BOTTOM_SPACE_MOB = 24;

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },

        '&:first-child': {
          marginTop: 76,
        },
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: colorsPalette.white,
        paddingLeft: 16,
        paddingRight: 16,
        width: '100%',
      },
      contentWrapper: {
        width: '100%',
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',

        [theme.breakpoints.up('lg')]: {
          flexDirection: 'row',
          alignItems: 'center',
          position: 'relative',

          '&$odd': {
            flexDirection: 'row-reverse',

            '& $textWrapper': {
              paddingLeft: 0,
              paddingRight: '8%',

              '&:first-child': {
                paddingRight: 0,
              },
            },
          },
        },
      },
      odd: {},
      heading: {
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        [theme.breakpoints.up('lg')]: {
          display: 'none',
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      singleImageWrap: {
        width: 343,
        height: 200,
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        [theme.breakpoints.up('lg')]: {
          display: 'flex',
          width: '50%',
          height: 350,
          marginBottom: 0,
        },
        '& img': {
          width: '100%',
          objectFit: 'contain',
          borderRadius: 5,
        },
      },
      firstImageWrap: {
        height: 200,
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        '& img': {
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          borderRadius: 5,
        },

        [theme.breakpoints.up('lg')]: {
          marginBottom: 40,
          width: '50%',
          height: 359,
          '& img': {
            objectFit: 'cover',
          },
        },
      },
      secondImageWrap: {
        height: 200,
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        '& img': {
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          borderRadius: 5,
        },

        [theme.breakpoints.up('lg')]: {
          position: 'absolute',
          bottom: 0,
          left: '20%',
          width: '36%',
          height: 253,
          marginBottom: 0,

          '& img': {
            objectFit: 'cover',
          },
        },
      },
      textWrapper: {
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        width: '100%',
        '&:last-child': {
          marginBottom: 0,
        },
        '& p': {
          width: '100%',
        },
        [theme.breakpoints.up('sm')]: {
          width: '50%',
        },

        [theme.breakpoints.up('lg')]: {
          display: 'flex',
          flexDirection: 'column',
          width: '50%',
          justifyContent: 'center',
          alignItems: 'center',
          paddingLeft: '8%',
          marginBottom: INNER_BOTTOM_SPACE_DESK,

          '&:first-child': {
            width: 'auto',
            paddingLeft: 0,

            '& p': {
              textAlign: 'center',
              maxWidth: '70%',
              width: '100%',
            },

            '& h2': {
              textAlign: 'center',
              fontSize: 28,
            },
          },
        },
      },
      itemHeading: {
        marginBottom: INNER_BOTTOM_SPACE_MOB,
        fontSize: 18,
        textAlign: 'center',
        display: 'none',
        [theme.breakpoints.up('lg')]: {
          display: 'block',
          fontSize: 22,
          textAlign: 'left',
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      itemText: {
        fontSize: 18,
        lineHeight: 1.5,
        textAlign: 'center',
        color: colorsPalette.gray,
        [theme.breakpoints.up('lg')]: {
          textAlign: 'left',
        },
      },
      leftAlign: {
        alignSelf: 'flex-start',
      },
    }),
  );
export default useStyles;
